import { Button, Group, Select, TextInput } from '@mantine/core'
import { IconSearch } from '@tabler/icons-react'
import { useState } from 'react'
import SaveButton from '../common/SaveButton'
import AddUserModal from './AddUserModal'

interface UserListHeaderSectionProps {
  filters: {
    level: string
    name: string
    phone: string
    state: string
  }
  onSearch: (filters: UserListHeaderSectionProps['filters']) => void
}

const UserListHeaderSection = ({
  filters,
  onSearch,
}: UserListHeaderSectionProps) => {
  const [modalOpened, setModalOpened] = useState(false)

  const handleFilterChange = (key: keyof typeof filters, value: string) => {
    const updated = { ...filters, [key]: value }
    onSearch(updated) // 바로 반영
  }

  const handleReset = () => {
    const resetFilters = { level: '', name: '', phone: '', state: '' }
    onSearch(resetFilters)
  }

  return (
    <div>
      <div
        style={{
          flexDirection: 'column',
          gap: '10px',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '25px',
          }}
        >
          <Group gap="xs">
            <SaveButton
              style={{ height: '34px' }}
              onClick={() => setModalOpened(true)}
            >
              Add User
            </SaveButton>
            <SaveButton style={{ height: '34px' }} onClick={handleReset}>
              Clear Filters
            </SaveButton>
          </Group>
        </div>

        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <Select
            data={[
              { value: '', label: '전체' },
              ...Array.from({ length: 12 }, (_, i) => ({
                value: (i + 1).toString(),
                label: `Level ${i + 1}`,
              })),
            ]}
            placeholder="Level"
            value={filters.level}
            onChange={(value) => handleFilterChange('level', value || '')}
            style={{ width: '150px' }}
          />

          <TextInput
            placeholder="Name"
            value={filters.name}
            onChange={(e) => handleFilterChange('name', e.currentTarget.value)}
            leftSection={<IconSearch size={16} />}
            style={{ width: '150px' }}
          />
          <TextInput
            placeholder="Phone"
            value={filters.phone}
            onChange={(e) => handleFilterChange('phone', e.currentTarget.value)}
            leftSection={<IconSearch size={16} />}
            style={{ width: '150px' }}
          />
          <Select
            data={[
              { value: '', label: '전체' },
              { value: 'Y', label: '활성화' },
              { value: 'N', label: '비활성화' },
            ]}
            placeholder="Status"
            value={filters.state}
            onChange={(value) => handleFilterChange('state', value || '')}
            style={{ width: '150px' }}
          />
        </div>
      </div>

      <AddUserModal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
      />
    </div>
  )
}

export default UserListHeaderSection
